/**
 * The one way to put the caret back in the utterance input.
 *
 * `AutocompleteComp` normally keeps itself focused on every render, but anything
 * marked `data-issue-report` deliberately holds focus against it (see
 * `focusOmniBarInput`). When such a surface closes, the caret would otherwise sit on
 * `<body>` until some unrelated re-render happens to run the omnibar's own refocus —
 * which is a bad moment to be unable to type an order.
 *
 * ⚠️ NODE, NOT ID. An earlier version looked the input up as `#omnitext`, the id set
 * on the omnibar's `TextField`. That id never reaches the DOM: MUI `Autocomplete`
 * supplies its own through `params.inputProps`, which is applied directly to the
 * input and beats the `id` prop, so the element is really `#mui-1`. The lookup
 * returned null and the handback silently did nothing. The node is registered here by
 * the same callback ref that does the refocusing, so it cannot drift again.
 */
let omniBarInput: HTMLInputElement | null = null;

export const setOmniBarInput = (input: HTMLInputElement | null) => {
  omniBarInput = input;
};

export const focusOmniBar = () => {
  // The node is re-registered on every render, but guard anyway: a stale node left
  // over from an unmounted layout must not be focused.
  if (omniBarInput && document.contains(omniBarInput)) {
    omniBarInput.focus();
  }
};

/** Test seam — clears the module-level node between cases. */
export const resetOmniBarInput = () => {
  omniBarInput = null;
};

export default focusOmniBar;
